import { useQuery } from '@tanstack/react-query';
import ReactMarkdown from 'react-markdown';
import { useApiClient } from '../../api/ApiClientContext';
import styles from './styles.module.scss';
import Spinner from '../spinner/Spinner';
import { getHabitImageByID } from '../../utils/habitImages';

interface IntroProgramStepProps {
  programmeId?: string;
  moduleId?: string;
}

const IntroProgramStep = ({ programmeId, moduleId }: IntroProgramStepProps) => {
  const apiClient = useApiClient();
  const {
    data: currentProgram,
    isLoading,
  } = useQuery({
    queryKey: ['programme', programmeId],
    enabled: !!programmeId,
    queryFn: async () => {
      const res = await apiClient.api.getProgrammeApiV1ProgrammesProgrammeIdGet(programmeId!);
      return res?.data;
    },
  });

  const currentModule = currentProgram?.modules?.find((m) => m.id === moduleId);

  const totalBehaviours = currentModule?.behaviours?.length ?? 0;
  const totalHabits = currentModule?.behaviours?.reduce(
    (sum, b) => sum + (b.habits_count ?? 0),
    0,
  ) ?? 0;

  if (isLoading) {
    return <Spinner />;
  }

  const displayName = currentModule?.name ?? currentProgram?.name ?? '';
  const moduleNumber = currentModule?.sequence_order ?? 1;

  return (
    <div className={styles['intro-program__main']}>
      <div className={styles['intro-program__main-title']}>
        Module {moduleNumber}
      </div>
      <div className={styles['intro-program__main-content']}>
        <div className={styles['intro-program__program-title']}>
          {currentModule?.description ?? currentProgram?.short_description ?? displayName}
        </div>
        <img
          src={getHabitImageByID('program-intro')}
          className={styles['intro-program__image']}
          alt="Module"
        />
        <div className={styles['intro-program__details']}>
          <div className={styles['intro-program__stats']}>
            <div className={styles['intro-program__stat']}>
              {currentModule?.duration_days ?? currentProgram?.duration_days ?? 0} DAYS
            </div>
            <div className={styles['intro-program__stat']}>
              {totalBehaviours} BEHAVIOUR{totalBehaviours !== 1 ? 'S' : ''}
            </div>
            <div className={styles['intro-program__stat']}>
              {totalHabits} HABIT{totalHabits !== 1 ? 'S' : ''}
            </div>
          </div>
          {(currentModule?.intro_content || currentProgram?.intro_content) && (
            <div className={styles['intro-program__intro-content']}>
              <ReactMarkdown>
                {currentModule?.intro_content ?? currentProgram?.intro_content ?? ''}
              </ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default IntroProgramStep;
